module.exports = __webpack_public_path__ + "img/logo-knop.18ca47ee.png";